<template>
  <div class="min-h-screen font-sans transition-colors duration-300">
    <div
      class="bg-background-light dark:bg-background-dark text-slate-800 dark:text-slate-100"
    >
      <main class="container mx-auto px-4 py-12 max-w-5xl">
        <div class="text-center mb-16">
          <h2
            class="text-3xl font-bold text-center mb-5 text-gray-700 title-underline uppercase"
          >
            Download Center
          </h2>
        </div>

        <div class="space-y-1">
          <div
            v-for="(category, index) in downloadList"
            :key="index"
            class="border-b border-gray-100"
          >
            <div
              @click="toggle(index)"
              class="flex items-center py-4 cursor-pointer hover:bg-gray-50 transition-colors"
            >
              <!-- activeIndexes.includes(index) -->
              <div
                :class="activeIndex == index ? 'bg-[#e91e63]' : 'bg-[#333333]'"
                class="w-5 h-5 flex items-center justify-center text-white text-xs mr-4 transition-colors"
              >
                {{ activeIndex == index ? '−' : '+' }}
              </div>
              <span class="text-sm font-medium text-gray-700">{{
                category.title
              }}</span>
            </div>

            <div v-show="activeIndex == index" class="pl-9 pb-8 pt-2">
              <div
                v-for="(file, fIndex) in category.files"
                :key="fIndex"
                class="mb-6 last:mb-0"
              >
                <div class="flex items-center text-xs mb-3 text-gray-600">
                  <span class="material-icons"> picture_as_pdf </span>
                  <span>{{ file.name }}.pdf</span>
                </div>
                <button
                  class="bg-primary text-white text-xs px-6 py-1.5 rounded-sm font-bold hover:bg-blue-800 transition"
                  @click="downloadPdf(category.title, file.name)"
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>

        <section class="py-16">
          <div class="container mx-auto px-8 py-8 bg-[#ededed]">
            <email-sender></email-sender>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
import EmailSender from '@/components/emailform/Email'
export default {
  name: 'Download',
  components: {
    EmailSender
  },
  data() {
    return {
      // 控制当前哪些索引是展开的
      activeIndexes: [2], // 默认展开第三个 (TDS-HCR)
      activeIndex: 0,
      downloadList: [
        { title: 'HTV MSDS', files: [{ name: 'HTV MSDS' }] },
        { title: 'LSR MSDS', files: [{ name: 'LSR MSDS' }] },
        {
          title: 'TDS-HTV',
          files: [
            {
              name: 'Technical Data Sheet of Electric Insulation Silicone Rubber'
            },
            { name: 'Technical Data Sheet of Silicone Rubber for Extrusion' },
            { name: 'Technical Data Sheet of Fire Retardant Silicone Rubber' },
            { name: 'Technical Data Sheet of General Purpose Silicone Rubber' },
            { name: 'Technical Data Sheet of High Resilience Silicone Rubber' },
            {
              name: 'Technical Data Sheet of High Tear Strength Silicone Rubber'
            },
            {
              name: 'Technical Data Sheet of High Temperature Resistant Silicone Rubber'
            },
            {
              name: 'Technical Data Sheet of High Transparent Fumed Silicone Rubber'
            },
            { name: 'Technical Data Sheet of Roller Silicone Rubber' }
          ]
        },
        {
          title: 'TDS-LSR',
          files: [
            {
              name: 'Technical Datasheet of Liquid Silicone Rubber for Baby Products'
            },
            {
              name: 'Technical Datasheet of Liquid Silicone Rubber for Cable Accessories'
            },
            {
              name: 'Technical Datasheet of Liquid Silicone Rubber for Food and Kitchen'
            },
            {
              name: 'Technical Datasheet of Liquid Silicone Rubber for Medical'
            },
            {
              name: 'Technical Datasheet of Liquid Silicone Rubber for Molding'
            },
            {
              name: 'Technical Datasheet of Self-Adhesive Liquid Silocone Rubber'
            }
          ]
        }
      ]
    }
  },
  methods: {
    downloadPdf(title, name) {
      console.log(title, name)
      // const link = document.createElement('a')
      // link.href = 'https://example.com/file.pdf' // PDF 地址
      // link.download = '产品手册.pdf' // 下载后的文件名
      // link.target = '_blank'
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)
      // 直接访问根路径下的 static 目录
      const link = document.createElement('a')

      // 注意：在开发环境和生产环境下，static 文件夹中的内容
      // 最终都会出现在服务器的 /static/ 目录下
      link.href = `./static/download/${title}/${name}.pdf`

      link.download = `${title}-${name}.pdf` // 下载后的文件名
      link.target = '_blank'

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    toggle(index) {
      if (this.activeIndex === index) {
        this.activeIndex = -1
      } else {
        this.activeIndex = index
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title-underline {
  position: relative;
  display: inline-block;
}
.title-underline::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 100%;
  height: 8px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 20" preserveAspectRatio="none"><path d="M0 15 Q 25 5, 50 15 T 100 15" stroke="%23004494" stroke-width="4" fill="transparent"/></svg>');
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/download/Download.vue